import React from 'react';
import ReactDOM from 'react-dom';
// import SecretSanta from './SecretSanta'
import Login from './Login'
let nD = new Date();
let eD = new Date(2026, 0, 1, 1);

function dd() {
  if (+nD < +eD) {
    return <Login />
  }
}

 ReactDOM.render(dd(), document.getElementById('root'));
